/**
 * Clientes (receptores de documentos) habilitados en el portal.
 *
 * El primer segmento del path del sitio identifica al cliente: `/{clientKey}/...`.
 * Ese segmento se mapea aquí al `accId` (workspace) que viaja en el header
 * `x-ax-workspace` de cada request al backend.
 *
 * El nombre a mostrar NO vive aquí: se resuelve en runtime desde Keycloak via
 * `GET /custom-resources/organizations/{acc_id}` (endpoint público; ver el store de sesión).
 *
 * El mapeo depende de la plataforma (realm) y el stage: se resuelve por el modo de
 * build `{plataforma}-{stage}` (ver scripts/run.js), disponible en `import.meta.env.MODE`.
 */
export interface ClientConfig {
  /** Alias de la organización cliente (acc_id / x-ax-workspace). */
  accId: string
}

type ClientMap = Record<string, ClientConfig>

const FAX_DEV_CLIENTS: ClientMap = {
  'axteroid-spa': { accId: 'cl-axt-dev' },
  'factura-x': { accId: 'cl-fx-dev' },
}

const CLIENTS_BY_MODE: Record<string, ClientMap> = {
  'fax-localhost': FAX_DEV_CLIENTS,
  'fax-dev': FAX_DEV_CLIENTS,
  'fax-prod': {},
}

const CLIENTS: ClientMap = CLIENTS_BY_MODE[import.meta.env.MODE] ?? {}

export function resolveClient(clientKey: string): ClientConfig | null {
  return CLIENTS[clientKey] ?? null
}

/** Búsqueda inversa: el clientKey (ruta) a partir del accId. Para el aterrizaje de invitaciones. */
export function resolveClientKeyByAccId(accId: string): string | null {
  const entry = Object.entries(CLIENTS).find(([, config]) => config.accId === accId)
  return entry ? entry[0] : null
}
